import React from 'react';

import HoverableCardsSection from 'src/organisms/Shared/HoverableCardsSection/HoverableCardsSection';

const WhoElseOnMighty = (): JSX.Element => {
  return (
    <HoverableCardsSection
      title='Who else is on Mighty?'
      subtitle={`Over 900K people like you have created a community on Mighty. Here are some of our favorites in our most popular categories.`}
    />
  );
};

export default WhoElseOnMighty;
